import { render, staticRenderFns } from "./InnerChatCards.vue?vue&type=template&id=0c0e0b67&scoped=true"
import script from "./InnerChatCards.vue?vue&type=script&lang=js"
export * from "./InnerChatCards.vue?vue&type=script&lang=js"
import style0 from "./InnerChatCards.vue?vue&type=style&index=0&id=0c0e0b67&prod&lang=css"
import style1 from "./InnerChatCards.vue?vue&type=style&index=1&id=0c0e0b67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e0b67",
  null
  
)

export default component.exports